import _isEmpty from 'underscore/cjs/isEmpty.js'

import { useUtmsStore } from './utms'

export const useLifeInsuranceStore = defineStore('life-insurance', {
  state: () => ({
    guides: {
      url: null,
      initialPage: ''
    },
    form: {},
    application: {},
    lifeAip:{}
  }),

  getters: {
    leadParams () {
      const form = this.form

      if (_isEmpty(form)) {
        return {}
      }

      const utmsStore = useUtmsStore()
      const formData = flattenObj(form, 1)

      let licUpsellItems = {}
      if (formData.hasOwnProperty('lic_upsell_items')) {
        licUpsellItems = {
          lic_upsell_items: formData?.lic_upsell_items
        }
      }

      const obj = {
        ...getName(formData?.full_name),
        age: formData?.age,
        life_cover: (formData?.annual_income && formData?.annual_income.replace(/[$,]/g, '')) || '',
        salary: 0,
        smoker: formData?.smoker,
        gender: formData?.gender,
        occupation: formData?.occupation?.id,
        occupationList: formData?.occupation?.name,
        occupation_omni_id: formData?.occupation?.omniumId,
        state: formData?.state,
        phone: formData?.phone,
        email: formData?.email,

        brand: 'CompareClub',
        form_page: import.meta.client && window.location.href,
        landing_page: utmsStore.GET_UTMS_LANDING_PAGE,
        trauma_sum_insured: formData.trauma_sum_insured ?? 0,
        tpd_sum_insured: formData.tpd_sum_insured ?? 0,
        viewed_quotes_c: '',
        ...licUpsellItems
      }

      return obj
    },
    getAipDetails (){
      return this.lifeAip
    }
  },

  actions: {
    async createLead (payload) {
      const utmsStore = useUtmsStore()

      // TODO: Remove the following use of Local Storage after moving the Life comparison
      setLocal('fields', JSON.stringify({
        ...payload,
        occupationData: {
          name: payload.occupationList
        }
      }))

      const response = await useFetch('/api/lead/create', {
        method: 'post',
        body: {
          vertical: 'Life Insurance',
          ...utmsStore.utms,
          ...payload
        }
      }).then(res => {
        const temp = res?.data.value

        if (temp?.error) {
          throw temp?.error
        }

        const data = temp?.data

        return data?.lead_uuid ?? undefined
      }).catch(error => {
        throw error
      })

      return response
    }
  },

  persist: {
    storage: piniaPluginPersistedstate.sessionStorage()
  }
})
